import styled from 'styled-components';
import CustomBlockButton from '../../../../../../../components/button/CustomBlockButton';
import _ from 'lodash';
import { useApiInfoContextValueHook } from '../../../../../../../contexts/ApiInfoContext';
import { SellertoolSignatureUtils } from '../../../../../../../utils/sellertool-signature-utils';
import { ReturnExchangesApi } from '../../../../../../../apis/ReturnExchangesApi';
import { useFetcher } from '../../../../fetcher/useFetcher';
import { CustomBackdropController } from '../../../../../../../components/backdrop/default/v1';
import { useEffect, useState } from 'react';
import { CustomDialog } from '../../../../../../../components/dialog/v1/CustomDialog';
import { CustomLabelInput } from '../../../../../../../components/input/CustomLabelInput';
import { customToast } from '../../../../../../../components/toast/custom-react-toastify/v1';
import { CustomDateUtils } from '../../../../../../../utils/CustomDateUtils';
import { ProductOptionsApi } from '../../../../../../../apis/ProductOptionsApi';
import { GlobalWegetProductOptionModal } from '../../../../../../../global-wegets/global-weget-product-option-modal';
import { CustomLabelTextarea } from '../../../../../../../components/textarea/CustomLabelTextarea';

const StyledTableCell = styled.td`
  padding: 16px;
  color: #495057;
  border-bottom: 1px solid #dee2e6;

  .view-button{
    background-color: var(--blueColor1);
    color: #fff;
    border-radius: 3px;
    border:none;
    height: 30px;
    padding: 0 10px;
    font-weight: 600;
    cursor: pointer;
  }
`

const StyledModalHeader = styled.div`
    padding: 10px;
`;

const StyledModalBody = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .textareaBox{
        border-color: #dee2e6;
        border-radius:3px;
    }

    .product-info-box{
        border: 1px solid #dee2e6;
        padding:10px;
        border-radius: 5px;
        font-size: 14px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .label{
            font-weight: 600;
            color:#333;
        }

        .content{
            padding-left: 5px;
            margin-top:5px;
        }
    }
`;

const StyledModalFooter = styled.div`
    padding: 10px;

    button{
        border-radius: 3px;
        background-color: var(--blueColor1);
        color: #fff;
        font-weight: 600;
        border:none;
    }
`;

export function TdClaimInfo({
    returnExchange
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const fetcher = useFetcher();

    const [editModalOpen, setEditModalOpen] = useState(false);

    const handleReqChange = async (editableData) => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }
        CustomBackdropController().showBackdrop();
        const response = await ReturnExchangesApi().updateList({
            headers: headers,
            body: {
                returnExchanges: [editableData]
            }
        });

        if (response?.content) {
            await fetcher.fetchReturnExchanges();
        }
        setEditModalOpen(false);
        CustomBackdropController().hideBackdrop();
    }
    return (
        <>
            <StyledTableCell>
                <CustomBlockButton
                    type='button'
                    className='view-button'
                    onClick={(e) => { e.stopPropagation(); setEditModalOpen(true) }}
                >보기</CustomBlockButton>
            </StyledTableCell>

            {editModalOpen &&
                <EditModal
                    open={editModalOpen}
                    onClose={() => setEditModalOpen(false)}
                    returnExchange={returnExchange}
                    onReqChange={handleReqChange}
                />
            }
        </>
    );
}

function EditModal({
    open,
    onClose,
    returnExchange,
    onReqChange
}) {
    const [editableReturnExchange, setEditableReturnExchange] = useState(_.cloneDeep(returnExchange));

    const handleChangeValue = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setEditableReturnExchange(prev => {
            return {
                ...prev,
                [name]: value
            }
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        onReqChange(editableReturnExchange);
    }

    return (
        <>
            <CustomDialog
                open={open}
                onClose={onClose}
            >
                <StyledModalHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>
                            클레임
                        </CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={() => onClose()} />
                    </CustomDialog.Header>
                </StyledModalHeader>
                <form onSubmit={handleSubmit}>
                    <StyledModalBody>
                        <CustomLabelTextarea
                            boxClassName='textareaBox'
                            labelElement='시스템 클레임'
                            value={editableReturnExchange?.claimSystem || ''}
                            onChange={handleChangeValue}
                            name='claimSystem'
                        ></CustomLabelTextarea>
                        <CustomLabelTextarea
                            boxClassName='textareaBox'
                            labelElement='고객 클레임'
                            value={editableReturnExchange?.claimCustomer || ''}
                            onChange={handleChangeValue}
                            name='claimCustomer'
                        ></CustomLabelTextarea>
                        <CustomLabelTextarea
                            boxClassName='textareaBox'
                            labelElement='배송비 지불방식'
                            value={editableReturnExchange?.returnExchangeDeliveryPaidMethod || ''}
                            onChange={handleChangeValue}
                            name='returnExchangeDeliveryPaidMethod'
                        ></CustomLabelTextarea>
                        <CustomLabelTextarea
                            boxClassName='textareaBox'
                            labelElement='고객요청수거방법'
                            value={editableReturnExchange?.customerRequestCollectionMethod || ''}
                            onChange={handleChangeValue}
                            name='customerRequestCollectionMethod'
                        ></CustomLabelTextarea>
                    </StyledModalBody>
                    <StyledModalFooter>
                        <CustomBlockButton
                            type='submit'
                        >적용</CustomBlockButton>
                    </StyledModalFooter>
                </form>
            </CustomDialog>
        </>
    );
}

/**
 * 이 페이지에서 수정되는 항목
exchange_release_option_code
exchange_release_quantity
exchange_re_shipment_at
exchange_re_shipment_waybill_number
exchange_re_shipment_destination
exchange_re_shipment_destination_detail
exchange_re_shipment_receiver
exchange_re_shipment_receiver_contact1
exchange_re_shipment_receiver_contact2
exchange_re_shipment_delivery_charge
 */